module.exports = __webpack_public_path__ + "static/media/swing.736d6341.png";